<mat-form-field [class]="class">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-select [id]="id + '-select'"
        [(value)]="value"
        (selectionChange)="change($event)"
        [multiple]="multiple"
        [disabled]="disabled">
        <mat-select-trigger>
            @if (value != 'None' && !multiple) {
            <span style="padding-right: .5em;">
                <app-businessdomain-icon [businessdomain]="value"
                    [size]="15"></app-businessdomain-icon>
            </span>
            }
            @if (!multiple && !!value) {
            <span>{{ 'task.businessDomain.' + value | blah }}</span>
            }
            @if (multiple && value?.length >= 1) {
            <span>
                {{ 'task.businessDomain.' + value[0] | blah }}
                @if (value?.length > 1) {
                <span>(+{{ value.length - 1 }})</span>
                }
            </span>
            }
        </mat-select-trigger>
        @if (!multiple && includeClearFilterOption && value != null) {
        <mat-option [value]="null">
            <div style="display: flex; align-items: center; padding-left: 40px;"
                [id]="id + '-select-clear-filter-option'">
                {{ 'task.businessDomain.clearFilter' | blah }}
            </div>
        </mat-option>
        }
        @for (businessDomain of businessDomains; track businessDomain) {
        <mat-option [value]="businessDomain.value">
            <div style="display: flex; align-items: center;"
                [id]="id + '-select-option-' + businessDomain.value">
                <div style="padding-left: 1em; order: 2;">{{ businessDomain.translatedValue }}</div>
                <div style="order: 1;">
                    <app-businessdomain-icon [businessdomain]="businessDomain.value"></app-businessdomain-icon>
                </div>
            </div>
        </mat-option>
        }
    </mat-select>
</mat-form-field>